import { PAGE_SIZE } from "features/ConsultRequest/core/constants";
import * as gql from "hooks/consultRequest";

// BE: fulfillment_be project_consult_request.proto qua GraphQL api_gateway (consultRequestAdmin, field ops).
// `client` là Apollo client từ useAppApolloClient; giữ chữ ký adapter cũ để component không đổi.

export const listConsultRequests = (client, params) => gql.fetchConsultRequests(client, { size: PAGE_SIZE, ...params });
export const getStatusCounts = (client, params) => {
  const { status, page, size, ...rest } = params || {};
  return gql.fetchStatusCounts(client, rest);
};
export const getProjectTypeOptions = (client) => gql.fetchProjectTypeOptions(client);
export const getConsultRequest = (client, id) => gql.fetchConsultRequest(client, id);
export const listAssignees = (client, keyword) => gql.fetchAssignees(client, keyword);
export const assignConsultRequest = (client, id, payload) => gql.mutateAssign(client, id, payload);
export const changeConsultStatus = (client, id, payload) => gql.mutateChangeStatus(client, id, payload);
export const listNotes = (client, id, params) => gql.fetchNotes(client, id, { size: PAGE_SIZE, ...params });
export const addNote = (client, id, content) => gql.mutateAddNote(client, id, content);
export const listFiles = (client, id) => gql.fetchFiles(client, id);
export const uploadFile = (client, id, file, { onUploadProgress, signal } = {}) =>
  gql.mutateUploadFile(client, id, file, { onUploadProgress, signal });
export const deleteFile = (client, id, fileId) => gql.mutateDeleteFile(client, id, fileId);
export const downloadFile = (client, id, fileId) => gql.fetchDownloadFile(client, id, fileId);
export const listHistories = (client, id, params) => gql.fetchHistories(client, id, { size: PAGE_SIZE, ...params });
